import debug from 'debug';

const log = debug('CookieService');
const consentTypes = ['necessary', 'preferences', 'statistics', 'marketing'];

export class CookieService {
	constructor() {
	}

	/**
	 * 
	 * @param {string} name The name of the cookie
	 * @param {number} type Cookiebot types 0:necessary, 1:preferences, 2:statistics, 3:marketing
	 * 
	 * @returns {string} The value of the found cookie, or empty string
	 */
	Get(name, type) {
		log('Get() - name', name);
		
		if (typeof type !== 'number') return;

		const consentType = consentTypes[type];
		log('Get() - cookiebot - type, consent', consentType, Cookiebot.consent[consentType]);
		if (Cookiebot.consent[consentType] === false) return;

		name = name + "=";
		let decodedCookie = decodeURIComponent(document.cookie);
		let cookieArray = decodedCookie.split(';');
		for(let i = 0; i <cookieArray.length; i++) {
			let cookie = cookieArray[i];
			while (cookie.charAt(0) == ' ') {
				cookie = cookie.substring(1);
			}
			if (cookie.indexOf(name) == 0) {
				log('Get() - EXCIST - name, value', name, cookie.substring(name.length, cookie.length));
				return cookie.substring(name.length, cookie.length);
			}
		}
		log('Get() - NO VALUE - name', name);
		return "";
	}

	/**
	 * Set a cookie
	 * 
	 * @param {object} options
	 * @param {string} options.name The name of the cookie
	 * @param {any} options.value The value 
	 * @param {number} [options.days] The number of days before the cookie expires, 0 for session cookie
	 * @param {number} options.type Cookiebot types 0:necessary, 1:preferences, 2:statistics, 3:marketing 
	 */
	Set(options) {
		log('Set() - options', options);

		if (typeof options.type !== 'number') return;

		const consentType = consentTypes[options.type];
		log('Set() - cookiebot - type, consent', consentType, Cookiebot.consent[consentType]);
		if (!Cookiebot.consent[consentType]) return;

		options.days = options.days || 0;
		
		if (options.days === 0) {
			document.cookie = options.name + "=" + options.value + ";path=/";
		} else {
			let date = new Date();
			date.setTime(date.getTime() + (options.days*24*60*60*1000));
			let expires = "expires="+ date.toUTCString();
			document.cookie = options.name + "=" + options.value + ";" + expires + ";path=/";
		}
	}

	/**
	 * Delete a specific cookie
	 * 
	 * @param {string} name Name of the cookie to delete
	 *  @param {number} options.type Cookiebot types 0:necessary, 1:preferences, 2:statistics, 3:marketing 
	 */
	Delete(name, type) {
		log('Delete()', name);

		if (typeof type !== 'number') return;

		const consentType = consentTypes[type];
		log('Delete() - cookiebot - type, consent', consentType, Cookiebot.consent[consentType]);
		if (!Cookiebot.consent[consentType]) return;

		document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/';
		
	}
}

export let cookieService = new CookieService();
